import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
} from 'intact';
import {getRestProps} from '../utils';
import {Input} from '../input';
import {Icon} from '../icon';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        children, className, editing, 
        value, validate, disabled, 
        tip, invalid
    } = this.get();
    
    const classNameObj = {
        'k-editable': true,
        'k-editing': editing,
        'k-disabled': disabled,
        'k-invalid': invalid,
        [className]: className,
        [makeStyles()]: true
    };
    
    return _$cv('div', {
        ...getRestProps(this),
        'className': _$cn(classNameObj)
    }, [
        (!disabled && !editing) ?
            _$cc(Icon, {
                'className': 'k-icon-edit k-editable-icon',
                'title': tip,
                'ev-click': this.edit,
                'hoverable': true
            }) :
            undefined,
        _$ce(2, 'div', (
            (!editing) ?
                children :
                _$cc(Input, {
                    'size': 'small',
                    'defaultValue': value,
                    'ev-blur': this.onBlur,
                    'ev-keydown': this.onKeydown,
                    'ref': this.inputRef,
                    'frozenOnInput': true
                }, null, this.inputRef)
        ), 0, 'c-ellipsis')
    ]);
};